// extracted by mini-css-extract-plugin
export default {"label":"Toggle_label__i81Zf","root":"Toggle_root__T0cum"};